import React from "react";
import Page from "../../../../layout/web/Page";
import Title from "../../../../components/Common/Title";
import Connector from "../../../../redux/connector";
import {Layout, Select, Input} from "antd";
import {GetUserToken} from "../../../../api/token";
import PluginAddDeleteList from "../../../../components/Common/PluginAddDeleteList2";
import {PostToPbx} from "../../../../api/http-post";
import {fetchDataEntity} from "../../../../api/entity-data";

const {TextArea} = Input;
const {Content} = Layout;
const {Option} = Select;

class SettingInvoiceLabourHeadingPage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            Data: [],
            Companies: [],
            Modules: [],
            Products: [],
            isLoading: false,
            company: "",
            component: "list",
            newEntry: {},
        }
    }

    componentDidMount = async () => {
        await fetchDataEntity("Companies", "client/entity", "company", this)
        await this.loadInitialData()
    }

    loadInitialData = async () => {
        await this.loadData("modules", "Modules");
    }
    loadData = async (targetEntity, stateKey) => {
        let _this = this;
        let userInfo = GetUserToken();
        let table = targetEntity;
        let hub = {};
        hub.Org = userInfo.Org;
        let post = {}
        post.AutoGenerate = false;
        post.HasUniqueKey = false;
        post.AutoGenerateField = "";
        post.Data = {};
        post.Params = {}
        post.Entity = table;
        let endpoint = "/common/entity/" + table + "/list";
        this.setState({
            isLoading: true,
        })

        await PostToPbx(post, endpoint, async (data) => {
            await _this.setState({
                [stateKey]: data.RESULT
            })
        });
    }

    getModuleList = () => {
        let ls = [];
        for (let i in this.state.Modules) {
            let row = this.state.Modules[i];
            if (row.org === this.state.newEntry.org) {
                ls.push({
                    key: row.name,
                    val: row.name
                });
            }
        }
        return ls;
    }
    getCompanyList = () => {
        let ls = [];
        for (let i in this.state.Companies) {
            let row = this.state.Companies[i];
            ls.push({
                key: row.CustomerNumber,
                val: row.Name,
            });
        }
        return ls;
    }

    render() {
        const modulesOptions = this.getModuleList();
        const companyOptions = this.getCompanyList();
        return (
            <Page {...this.props}>
                <div style={{
                    minHeight: "100%",
                    maxHeight: "100%",
                }}>
                    <Title style={styles.title}>Setup Invoice Heading Info</Title>
                    <div style={{minWidth: "100%", padding: 10}}>
                        <PluginAddDeleteList
                            _this={this}
                            targetEntity={"InvoiceLabourHeading"}
                            depending={{
                                "org": {
                                    targetKey: "CustomerNumber",
                                    displayKey: "Name",
                                    storageTable: "Companies"
                                }
                            }}
                            fields={[
                                {
                                    name: "org",
                                    dataType: "option",
                                    required: true,
                                    label: "Company",
                                    options: companyOptions,
                                    depending: {stateKey: "org", displayKey: "Name", storageTable: "Companies"}
                                },
                                {
                                    name: "project",
                                    dataType: "option",
                                    required: true,
                                    label: "Project & Contract",
                                    options: modulesOptions,
                                },
                                {
                                    name: "pobox",
                                    dataType: "string",
                                    required: true,
                                    label: "Address PoBox",
                                    options: []
                                },
                                {
                                    name: "city",
                                    dataType: "string",
                                    required: true,
                                    label: "Address City",
                                    options: []
                                },
                                {
                                    name: "companyregister",
                                    dataType: "string",
                                    required: true,
                                    label: "Company Register",
                                    options: []
                                },
                                {
                                    name: "vatno",
                                    dataType: "string",
                                    required: true,
                                    label: "Company Vat Number",
                                    options: []
                                },
                                {
                                    name: "vendornumber",
                                    dataType: "string",
                                    required: true,
                                    label: "Vendor Number",
                                    options: []
                                },

                                /* client infor*/
                                {
                                    name: "invtocompany",
                                    dataType: "string",
                                    required: true,
                                    label: "Client Name",
                                    options: []
                                },
                                {
                                    name: "invtoaddressline1",
                                    dataType: "string",
                                    required: true,
                                    label: "Client Address Line1",
                                    options: []
                                },
                                {
                                    name: "invtoaddressline2",
                                    dataType: "string",
                                    required: true,
                                    label: "Client Address Line2",
                                    options: []
                                },
                                {
                                    name: "invtoavatno",
                                    dataType: "string",
                                    required: true,
                                    label: "Client Vat Number",
                                    options: []
                                },

                                /*  contact number */
                                {
                                    name: "contractnumber",
                                    dataType: "string",
                                    required: true,
                                    label: "Contract Number",
                                    options: []
                                },
                                {
                                    name: "contractdescription",
                                    dataType: "string",
                                    required: true,
                                    label: "Contract Description",
                                    options: []
                                },
                                {
                                    name: "arearegion",
                                    dataType: "string",
                                    required: true,
                                    label: "Area Region",
                                    options: []
                                },
                                {
                                    name: "invoicedesignation",
                                    dataType: "string",
                                    required: true,
                                    label: "Target Designations",
                                    options: []
                                },

                                {
                                    name: "bankholder",
                                    dataType: "string",
                                    required: true,
                                    label: "Bank Holder",
                                    options: []
                                },
                                {
                                    name: "bankname",
                                    dataType: "string",
                                    required: true,
                                    label: "Bank Name",
                                    options: []
                                },
                                {
                                    name: "bankaccount",
                                    dataType: "string",
                                    required: true,
                                    label: "Bank Account",
                                    options: []
                                },
                                {
                                    name: "bankbranch",
                                    dataType: "string",
                                    required: true,
                                    label: "Bank Branch",
                                    options: []
                                },
                                {
                                    name: "designationkeypersonnel",
                                    dataType: "string",
                                    required: true,
                                    label: "Designation of KeyPersonnel",
                                    options: []
                                },
                            ]}
                            deleteKeys={[
                                {key: "org", type: "string"},
                                {key: "project", type: "string"},
                            ]}
                            stateArray={"Data"}
                            table={"InvoiceLabourHeading"}
                            addFormText={"Invoice Heading Info Setup"}
                            stepTitle={"Set Up new invoice heading info"}
                        />

                    </div>
                </div>
            </Page>
        )
    }

}

export default Connector(SettingInvoiceLabourHeadingPage);

const styles = {
    container: {},
    title: {
        minWidth: "100%",
        borderBottomWidth: 1,
        borderColor: "gray"
    }
}

